const MyText = ({
  h0,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h7,
  h8,
  h9,
  h10,
  h11,
  h12,
  h13,
  p,
  bold,
  medium,
  light,
  thin,
  italic,
  title,
  style,
  children,
  center,
  right,
  color,
  fontSize,
  u,
  maxLines,
  overflowHidden,
  noSelect,
  ...rest
}) => {
  var styles = [
    { fontFamily: "poppinsregular", color: "white", display: "inline-block" },

    h0 && { fontSize: "7vw" }, // Responsive font size using vw
    h1 && { fontSize: "3vw" }, // Responsive font size using vw
    h2 && { fontSize: "2.5vw" }, // Responsive font size using vw
    h3 && { fontSize: "2vw" }, // Responsive font size using vw
    h4 && { fontSize: "1.8vw" }, // Responsive font size using vw
    h5 && { fontSize: "1.6vw" }, // Responsive font size using vw
    h6 && { fontSize: "1.4vw" }, // Responsive font size using vw
    h7 && { fontSize: "1.2vw" }, // Responsive font size using vw
    h8 && { fontSize: "1vw" }, // Responsive font size using vw
    h9 && { fontSize: "0.8vw" }, // Responsive font size using vw
    h10 && { fontSize: "0.6vw" }, // Responsive font size using vw
    h11 && { fontSize: "0.4vw" }, // Responsive font size using vw
    h12 && { fontSize: "0.2vw" }, // Responsive font size using vw
    h13 && { fontSize: "0.1vw" }, // Responsive font size using vw
    p && { fontSize: "1.4vw" }, // Responsive font size using vw
    u && { textDecorationLine: "underline" },

    maxLines && {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: maxLines,
    },
     overflowHidden && { overflow: "hidden" },

    fontSize && { fontSize: `${fontSize}vw` }, // Custom responsive font size using vw
    color && { color },
    center && {
      textAlign: "center",
      display: "block",
    },
    right && {
      textAlign: "right",
      display: "block",
    },
    bold && { fontFamily: "poppinsbold" },
    medium && { fontFamily: "poppinsmedium" },
    light && { fontFamily: "poppinslight" },
    thin && { fontFamily: "poppinsthin" },
    italic && { fontStyle: "italic" },
    style,
  ];

  // merge styles into one object

  styles = Object.assign({}, ...styles);
  const classes = [noSelect ? "noselect" : ""];
  const classNames = [...classes].join(" ");

  return (
    <div style={styles} {...rest} className={classNames}>
      {children}
    </div>
  );
};

export default MyText;
